import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history', // 去掉url中的#
  base: process.env.BASE_URL,
  routes: [
    // { path: "/index.html", redirect: { name: "login" } },
    {
      path: '',
      name: 'index',
      component: () => import('../views/index.vue'),
      // redirect: '/login',
      children: [
        // 主页
        {
          path: '',
          name: 'home',
          component: () => import('../views/index/index.vue'),
        },
        // 登录
        {
          path: 'login',
          name: 'login',
          component: () => import('../views/login/login.vue'),
        },
        // 法官登录
        {
          path: 'login_faguan',
          name: 'login_faguan',
          component: () => import('../views/login/login_faguan.vue'),
        },
        // 微信登录绑定
        {
          path: 'login_wechat',
          name: 'login_wechat',
          component: () => import('../views/login/login_wechat.vue'),
        },
        // 首页
        {
          path: 'home',
          name: 'home',
          component: () => import('../views/index/index.vue'),
        },
        // 法官首页
        {
          path: 'faguanhome',
          name: 'faguanhome',
          component: () => import('../views/index/index_faguan.vue'),
        },
        //页面路由配置
        {path:'empty',name:'empty',component: () => import('../views/empty/empty')}, 
        {path:'alltype',name:'alltype',component: () => import('../views/index/alltype')}, 
        // {path:'PartyList',name:'PartyList',component: () => import('../views/Party/PartyList')},  
        {path:'callsing',name:'callsing',component: () => import('../views/sing/callsing')},
        {path:'msgboard',name:'msgboard',component: () => import('../views/msgboard/msgboard')},
        {path:'idcard',name:'idcard',component: () => import('../views/yanzheng/idcard')},
        {path:'xinxi',name:'xinxi',component: () => import('../views/yanzheng/xinxi')},
        {path:'photo',name:'photo',component: () => import('../views/yanzheng/photo')},
        {path:'renzheng',name:'renzheng',component: () => import('../views/yanzheng/renzheng')},
        {path:'xuzhi_face',name:'xuzhi_face',component: () => import('../views/yanzheng/xuzhi_face')},//人脸识别须知
        {path:'huifufankui',name:'huifufankui',component: () => import('../views/12368/faguan/huifufankui')},
        {path:'dengjixinxi',name:'dengjixinxi',component: () => import('../views/12368/faguan/dengjixinxi')},
        {path:'liuyanban',name:'liuyanban',component: () => import('../views/12368/faguan/liuyanban')},
        {path:'anjianliuyan_faguan',name:'anjianliuyan_faguan',component: () => import('../views/anjianliuyan/faguan/anjianliuyan_faguan')},
        {path:'faguanlist_faguan',name:'liuyanfaguan',component: () => import('../views/liuyanfaguan/faguan/faguanlist')},
        {path:'daiwoshenhe',name:'daiwoshenhe',component: () => import('../views/shengxiaozhengming/faguan/daiwoshenhe')},
        {path:'shenheliucheng',name:'shenheliucheng',component: () => import('../views/shengxiaozhengming/faguan/shenheliucheng')},
        {path:'success',name:'success',component: () => import('../views/shengxiaozhengming/faguan/success')},

        {path:'liuyanlist',name:'liuyanlist',component: () => import('../views/12368/dsr/liuyanlist')},
        {path:'dengjixinxi_dsr',name:'dengjixinxi_dsr',component: () => import('../views/12368/dsr/dengjixinxi')},
        {path:'liuyanban_dsr',name:'liuyanban_dsr',component: () => import('../views/12368/dsr/liuyanban_dsr')},
        {path:'anjianliuyan_dsr',name:'anjianliuyan_dsr',component: () => import('../views/anjianliuyan/dsr/anjianliuyan_dsr')},
        {path:'anjianliuyan_admin',name:'anjianliuyan_admin',component: () => import('../views/anjianliuyan/admin/anjianliuyan_admin')},
        {path:'faguanlist',name:'faguanlist',component: () => import('../views/liuyanfaguan/user/faguanlist')},
        {path:'apply_liuyanfaguan',name:'apply_liuyanfaguan',component: () => import('../views/12368/dsr/apply')},//12368留言法官表单
        {path:'yongjun',name:'yongjun',component: () => import('../views/yongjun/yongjun')},
        // {path:'liuyanfaguan',name:'liuyanfaguan',component: () => import('../views/liuyanfaguan/faguan/liuyanfaguan')},
        {path:'download',name:'download',component: () => import('../views/download/download')},
        {path:'rukou',name:'rukou',component: () => import('../views/shengxiaozhengming/user/rukou')},
        {path:'apply',name:'apply',component: () => import('../views/shengxiaozhengming/user/apply')},
        {path:'apply_pc',name:'apply_pc',component: () => import('../views/shengxiaozhengming/user/apply_pc')},//自助机端申请表单
        {path:'jinduliucheng',name:'jinduliucheng',component: () => import('../views/shengxiaozhengming/user/jinduliucheng')},
        {path:'cailiaoshenqing',name:'cailiaoshenqing',component: () => import('../views/cailiaoshenqing/user/cailiaoshenqing')},
        {path:'tiqishenqing',name:'tiqishenqing',component: () => import('../views/cailiaoshenqing/user/tiqishenqing')},//材料申领申请表单
        // {path:'tiqishenqing_pc',name:'tiqishenqing_pc',component: () => import('../views/cailiaoshenqing/user/tiqishenqing_pc')},//自助机材料申领申请表单
        {path:'jindu',name:'jindu',component: () => import('../views/cailiaoshenqing/user/jindu')},//进度详情(当事人端)
        {path:'jindu_faguan',name:'jindu_faguan',component: () => import('../views/cailiaoshenqing/shenheren/jindu')},//进度详情(法官端)
        {path:'shenherencaozuo',name:'shenherencaozuo',component: () => import('../views/cailiaoshenqing/shenheren/shenherencaozuo')},//审核人列表
        {path:'shenlingshenpi1',name:'shenlingshenpi1',component: () => import('../views/cailiaoshenqing/shenheren/shenlingshenpi1')},//审批页面
        {path:'addliucheng',name:'addliucheng',component: () => import('../views/cailiaoshenqing/shenheren/addliucheng')},//绑定材料流程
        {path:'temp',name:'temp',component: () => import('../views/cailiaoshenqing/shenheren/temp')},//人员选模板
        {path:'tjyList',name:'tjyList',component: () => import('../views/tiaojieyuan/tjyList')},//调解员列表
        {path:'tjySing',name:'tjySing',component: () => import('../views/tiaojieyuan/tjySing')},//调解员详情
        {path:'tjcaseList',name:'tjcaseList',component: () => import('../views/tjcase/tjcaseList')},//调解案件列表
        {path:'authorized',name:'authorized',component: () => import('../views/wechat/authorized')},//微信授权中转页
        {path:'wechatBind',name:'wechatBind',component: () => import('../views/wechat/wechatBind')},//微信绑定中转页
        {path:'transformation',name:'transformation',component: () => import('../views/transferStation/transformation')},//飞飞中转页
        {path:'wangsuBind',name:'wangsuBind',component: () => import('../views/wangsuBind/wangsuBind')},//网诉绑定开启页
        {path:'wangsuloading',name:'wangsuloading',component: () => import('../views/wangsuBind/wangsuloading')},//网诉绑定等待页
        {path:'wangsuSucceful',name:'wangsuSucceful',component: () => import('../views/wangsuBind/wangsuSucceful')},//网诉绑定成功页
        {path:'xuzhi_shengxiaozhengming',name:'xuzhi_shengxiaozhengming',component: () => import('../views/shengxiaozhengming/user/xuzhi_shengxiaozhengming')},//开具生效须知
        {path:'xuzhi_cailiaoshenqing',name:'xuzhi_cailiaoshenqing',component: () => import('../views/cailiaoshenqing/user/xuzhi_cailiaoshenqing')},//材料申请须知
        {path:'wenshu',name:'wenshu',component: () => import('../views/wenshu/wenshu')},//文书模板
        {path:'tips',name:'tips',component: () => import('../views/others/tips')},//验证码注意事项提示
        {path:'judgeAuthorize',name:'judgeAuthorize',component: () => import('../views/login/judgeAuthorize')},//法官微信授权
        {path:'judgeMiddle',name:'judgeMiddle',component: () => import('../views/others/judgeMiddle')},//法官中转页
        {path:'faceToFace',name:'faceToFace',component: () => import('../views/faceToFace/faceToFace')},//面对面当事人版
        {path:'faceToFace_faguan',name:'faceToFace_faguan',component: () => import('../views/faceToFace/faceToFace_faguan')},//面对面法官版
        // {path:'faceToFace',name:'faceToFace',component: () => import('../views/faceToFace/faceToFace')},//古田法院民企面对面
        {path:'sifazhuxing',name:'sifazhuxing',component: () => import('../views/sifazhuxing/sifazhuxing')},//司法助兴
        {path:'dianduidian',name:'dianduidian',component: () => import('../views/dianduidian/dianduidian')},//执行点对点
        
        {path:'dianjilv',name:'dianjilv',component: () => import('../views/dianjilvtongji/dianjilv')},//点击率
    
        
       
        // 全部分类
        // {
        //   path: 'alltype',
        //   name: 'alltype',
        //   component: () => import('../views/index/alltype.vue'),
        // },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js